var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 74,
    viewBox: "0 0 222 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.307 54.9619H134.682L134.313 41.869C134.278 40.5266 134.434 39.2236 134.434 39.2236H134.355C134.355 39.2236 133.939 40.4892 133.255 41.869L126.697 54.9619H121.038L120.893 30.0768H127.186L126.538 44.6177C126.477 46.0307 126.255 47.4357 126.255 47.4357H126.341C126.341 47.4357 126.829 46.0307 127.525 44.6177L134.576 30.0768H139.134L139.165 44.6177C139.144 45.9877 138.962 47.4357 138.962 47.4357H139.038C139.038 47.4357 139.499 45.9877 140.111 44.6177L146.533 30.0768H152.315L140.307 54.9619Z",
    fill: "#00A1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.723 54.9619L155.677 30.0768H171.664L169.431 34.0186H161.134L159.628 40.3479H168.27L166.058 44.1829H158.706L157.077 51.0164H166.667L164.424 54.9619H149.723Z",
    fill: "#00A1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.151 54.9619L176.099 30.0768H182.467L177.462 51.0164H185.639L183.408 54.9619H170.151Z",
    fill: "#00A1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.433 54.9619L194.385 30.0768H200.757L195.749 51.0164H203.92L201.692 54.9619H188.433Z",
    fill: "#00A1D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.296 29.7157C100.202 29.7157 95.8808 34.8157 93.9937 41.2421C89.8143 40.83 85.7754 40.5162 82.0246 40.2786L83.5174 34.0186H91.8168L94.049 30.0768H78.0478L75.6965 39.9328C65.7759 39.4729 59.0222 39.5423 59.0222 39.5423C59.0222 39.5423 58.1042 39.5601 56.4548 39.608C58.1122 35.6723 60.7933 33.8755 64.3292 33.8755C66.6424 33.8755 67.9173 34.3078 68.6701 34.7776L71.3868 31.1631C69.8707 30.2573 67.7576 29.7163 64.5705 29.7163C57.7106 29.7163 52.3054 33.7134 49.8835 39.8407C41.1549 40.1957 27.1329 40.9528 12.0663 42.4966L12 42.7938H104.625L104.681 42.4966C103.211 42.2958 101.744 42.1061 100.286 41.9298C101.301 37.8118 103.041 33.5863 106.364 33.5863C109.747 33.5863 109.38 38.0672 108.376 42.3007C107.346 46.5711 105.699 51.017 102.193 51.017C99.1219 51.017 99.1256 47.5069 99.8779 43.7303C97.6444 43.9588 95.4491 44.1547 93.2967 44.3315C92.3044 50.527 94.278 55.323 101.172 55.323C108.716 55.323 113.118 49.5709 114.812 42.5218C116.483 35.5028 114.839 29.7157 107.296 29.7157ZM61.4976 44.921C61.4976 44.921 60.2928 44.8946 58.1509 44.8258V47.0298H61.9232L60.9591 50.9096C60.5636 51.0938 59.8881 51.2731 58.8663 51.2731C56.2435 51.2731 54.3141 48.869 54.965 44.7147C53.1799 44.6441 51.0926 44.5557 48.7449 44.4377C47.5149 51.259 51.2535 55.3224 58.2571 55.3224C61.9545 55.3224 64.2321 54.8145 66.2285 53.8719L68.4429 44.8473C64.1032 44.9493 61.4976 44.921 61.4976 44.921ZM81.0525 44.3309C78.7374 44.4666 76.5691 44.5735 74.5604 44.66L72.0979 54.9619H86.8089L89.0424 51.0164H79.4547L81.0525 44.3309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.612 16.597C127.036 19.0755 126.131 20.2201 124.492 20.2201C124.114 20.2201 123.781 20.1538 123.589 20.0844L125.169 13.2306C125.446 13.1373 125.728 13.0992 126.103 13.0992C127.707 13.0992 128.156 14.2254 127.612 16.597ZM129.396 16.6271C130.029 13.8975 129.213 12 126.315 12C125.219 12 124.28 12.2112 123.581 12.5152L121.653 20.8698C122.163 21.1849 123.062 21.3844 124.25 21.3844C127.144 21.3844 128.771 19.3426 129.396 16.6271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.542 17.9259H135.983L137.753 14.7161C138.14 14.0424 138.268 13.6163 138.268 13.6163H138.299C138.299 13.6163 138.238 14.0424 138.296 14.7161L138.542 17.9259ZM140.587 21.2536L139.538 12.1283H137.86L132.58 21.2536H134.173L135.474 18.9072H138.567L138.762 21.2536H140.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.069 21.2536L148.176 12.1283H152.838L152.575 13.2589H149.687L149.045 16.0192H151.622L151.366 17.1288H148.791L148.101 20.1274H150.996L150.733 21.2536H146.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.383 21.2536L159.712 16.6369H159.682L158.614 21.2536H156.848L158.956 12.1283H160.722L159.76 16.2949H159.793L163.497 12.1283H165.307L161.335 16.344L163.364 21.2542L161.383 21.2536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.176 21.2536L171.278 12.1283H175.948L175.679 13.2589H172.787L172.152 16.0192H174.722L174.466 17.1288H171.895L171.201 20.1274H174.102L173.834 21.2536H169.176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.202 21.3912C181.319 21.3912 180.308 20.2576 180.694 18.6026L182.182 12.1277H183.951L182.459 18.5842C182.238 19.5667 182.779 20.1004 183.57 20.1004C184.384 20.1004 185.144 19.5667 185.374 18.5842L186.866 12.1277H188.506L187.008 18.6026C186.623 20.2576 185.084 21.3912 183.202 21.3912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.688 21.2536C200.737 21.0289 201.479 15.2264 201.479 15.2264C201.559 14.6541 201.693 14.1223 201.693 14.1223H201.657C201.657 14.1223 201.447 14.6369 201.126 15.2264C201.126 15.2264 198.096 20.9484 197.913 21.2536H196.915C196.876 20.9853 196.496 15.208 196.496 15.208C196.463 14.6369 196.465 14.1223 196.465 14.1223H196.445C196.445 14.1223 196.336 14.6369 196.151 15.208C196.151 15.208 194.219 20.9853 194.14 21.2536H192.649L195.823 12.1283H197.611L197.972 17.9787C198.007 18.559 197.988 19.0012 197.988 19.0012H198.012C198.012 19.0012 198.186 18.559 198.494 17.9787L201.621 12.1283H203.398L202.368 21.2536H200.688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7_76",
    x: 0,
    y: 0,
    width: 221.92,
    height: 73.323,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0463021 0 0 0 0 0.115283 0 0 0 0 0.529167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_76"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_76",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/로고.98faa4971e9c41b7efa9002e9376a8f6.svg";
export { ForwardRef as ReactComponent };